/* JCS touch fix: reliable quick-add "+" on touch devices (homepage AI carousels). */
(function () {
  var sx = 0, sy = 0, moved = false;
  var SEL = '[class*="ai-product-carousel__quick-add-"]';

  document.addEventListener('touchstart', function (e) {
    var b = e.target.closest && e.target.closest(SEL);
    if (!b) return;
    var t = e.touches[0]; sx = t.clientX; sy = t.clientY; moved = false;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!e.touches[0]) return;
    if (Math.abs(e.touches[0].clientX - sx) > 8 || Math.abs(e.touches[0].clientY - sy) > 8) moved = true;
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    var b = e.target.closest && e.target.closest(SEL);
    if (!b || moved) return;
    var vid = b.getAttribute('data-variant-id');
    if (!vid || b.dataset.jcsBusy) return;
    e.preventDefault();   // suppress the synthetic click -> no double add
    e.stopPropagation();
    b.dataset.jcsBusy = '1';
    b.textContent = '\u2026';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(vid), quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw 0;
      window.location.href = '/cart';
    }).catch(function () {
      b.textContent = '!';
      setTimeout(function () { b.textContent = '+'; delete b.dataset.jcsBusy; }, 1200);
    });
  }, { passive: false });
})();
